<template>
  <div 
    class="card" 
    :class="{ activo: isActive, 'no-hover': noHover, 'is-open': isOpen }" 
    @click="handleClick"
  >
    <div class="card-header">
      <div class="title">
        <span v-if="collapsible" class="chevron" :class="{ 'chevron-closed': !isOpen }">▼</span>
        <slot name="icon" />
        <h3>{{ title }}</h3>
      </div>
      <div class="actions" @click.stop>
        <slot name="action" />
      </div>
    </div>

    <div class="card-body" v-show="!collapsible || isOpen" @click="collapsible && $event.stopPropagation()">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  title: String,
  isActive: { type: Boolean, default: false }, // ⬅️ igual que los botones
  noHover: { type: Boolean, default: false },
  collapsible: { type: Boolean, default: false }
});

const emit = defineEmits(['click']);

const isOpen = ref(false);

function handleClick(e) {
  if (props.collapsible) {
    isOpen.value = !isOpen.value;
  } else {
    emit('click', e);
  }
}
</script>


<style scoped>
.card {
  background: white;
  border-radius: 18px;
  padding: 16px;
  box-shadow: 0 6px 16px rgba(0,0,0,0.06);
  cursor: pointer;
  transition: all 0.25s ease;
  color: black;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.card:active {
  /* Evitar destello en móviles al hacer tap */
  background: white;
}

.card:not(.no-hover):hover {
  background: #678AB2;
  color: white;
}

.card:not(.no-hover):hover:active {
  /* Mantener color azul en :active cuando está en hover */
  background: #678AB2;
}

.card.activo {
  background: #678AB2;
  color: white;
}

.card.activo:active {
  /* Mantener color azul en :active cuando está activo */
  background: #678AB2;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.card.is-open .card-header {
  border-bottom-color: #eee;
  margin-bottom: 12px;
}

.title {
  display: flex;
  gap: 8px;
  align-items: center;
}

.chevron {
  font-size: 12px;
  color: #666;
  width: 20px;
  text-align: center;
  transition: transform 0.25s ease;
}

.chevron-closed {
  transform: rotate(-90deg);
}

h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: inherit;
}

.actions {
  display: flex;
  gap: 8px;
}

.action {
  background: #678AB2;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

/* Tablet */
@media (min-width: 768px) {
  .card {
    padding: 20px;
  }

  h3 {
    font-size: 18px;
  }

  .action {
    padding: 8px 16px;
    font-size: 14px;
  }
}

/* Desktop */
@media (min-width: 1024px) {
  .card {
    padding: 24px;
  }

  h3 {
    font-size: 20px;
  }

  .action {
    padding: 10px 20px;
    font-size: 15px;
  }
}
</style>
